import { createTheme } from '@mui/material/styles';
import { hexToRgb } from 'src/utilities/colorUtils';

declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    footer: true;
  }
}

declare module '@mui/material/styles/createPalette' {
  interface Palette {
    purple: {
      dark: string;
      primary: string;
      soft: string;
      light: string;
      extraLight: string;
      purpleTag: string;
      buttonBorder: string;
      ultraExtraLight: string;
      demoPurple:string
    };
    lightGreenTint:string
    chateauGreen:string
    serenade:string
    orangePeel:string
    mangolia:string
    electricViolet:string
    chablis:string,
    quarterPearlLusta:string,
    amber: string,
    basic: {
      steel: string;
      darkGrey: string;
      grey: string;
      red: string;
      absoluteRed:string,
      lightGrey: string;
      white?: string;
      softGrey: string;
      textColor: string;
      yellow: string;
      black: string;
    };
    blue: {
      aliceBlue:string;
      blue: string;
      accentBlue: string;
    };
    linkColor:string;
    primaryColor: any;
    cardBackground: string;
    transparent: string;
    mainLight: string;
    mainDark: string;
    green: string;
    lightGray: string;
    extraLightGray: string;
    borderColor: string;
    gray: {
      zincGray: string;
      extraLightGray: string,
      lightGray: string,
      softGray: string,
      gray: string,
      darkGray: string,
      extraDarkGray: string,
      rainGray: string,
      lightSoftGray: string,
      placeholderLightGray: string,
      disabledBackgroundGray: string,
      disabledGray: string,
      transparentGray: string,
      backgroundGray : string,
      demoGray:string
    };
    card: {
      platinum: string,
      business: string,
      fleet: string,
    }
  }
  // allow configuration using `createTheme`
  interface PaletteOptions {
    purple?: {
      dark?: string;
      primary?: string;
      soft?: string;
      light?: string;
      extraLight?: string;
      purpleTag: string;
      buttonBorder: string;
      ultraExtraLight: string;
      demoPurple:string;
    };
    lightGreenTint:string
    chateauGreen:string
    serenade:string
    orangePeel:string
    mangolia:string
    electricViolet:string
    chablis:string,
    quarterPearlLusta:string,
    amber: string,
    basic?: {
      absoluteRed:string,
      steel?: string;
      darkGrey?: string;
      grey?: string;
      lightGrey: string;
      white?: string;
      softGrey: string;
      textColor: string;
      yellow: string;
    };
    blue: {
      accentBlue: string;
      aliceBlue: string;
      blue:string
    };
    linkColor:string;
    primaryColor: any;
    cardBackground: string;
    transparent: string;
    mainLight: string;
    mainDark: string;
    green: string;
    lightGray: string;
    extraLightGray: string,
    borderColor: string;
    gray: {
      extraLightGray: string,
      lightGray: string,
      softGray: string,
      gray: string,
      darkGray: string,
      extraDarkGray: string,
      rainGray: string,
      lightSoftGray: string,
      placeholderLightGray: string,
      disabledBackgroundGray: string,
      disabledGray: string,
      transparentGray: string,
      zincGray: string;
      backgroundGray: string;
      demoGray:string
    };
    card: {
      platinum: string,
      business: string,
      fleet: string,
    }
  }
}

export const loadThemes = (SiteSettings: any) => {
  let theme = createTheme({});
  theme = createTheme(theme, {
    palette: {
      purple: {
        dark: SiteSettings.primaryDarkColor(),
        primary: SiteSettings.mainColor(),
        light: '#DFD7F5',
        extraLight: SiteSettings.extraLightColor(),
        soft: SiteSettings.extraLightColor(),
        purpleTag: '#F9F7FD',
        buttonBorder: SiteSettings.buttonBorderActiveColor(),
        ultraExtraLight: hexToRgb(SiteSettings.mainColor(), 0.05),
        demoPurple:"#6600FF"
      },
      lightGreenTint:"#F5FFF6",
      chateauGreen:"#34A853",
      serenade:"#FFF5E6",
      orangePeel:"#FF9A00",
      mangolia:"#F9F6FF",
      electricViolet:"#9900FF",
      chablis:"#FFF5F5",
      quarterPearlLusta:"#FFFDF5",
      amber: "#E6D107",
      basic: {
        steel: SiteSettings.buttonColor(),
        darkGrey: '#39444E',
        grey: '#6B737C',
        red: '#CA0813',
        absoluteRed:"#FF0000",
        lightGrey: SiteSettings.buttonBorderColor(),
        white: '#fff',
        softGrey: '#B5B9BC',
        textColor: SiteSettings.textColor(),
        yellow: '#f9cb40',
        black: '#000',
      },
      blue: {
        accentBlue: '#2BACEE',
        blue: "#0000FF",
        aliceBlue: "#F5FCFF"
      },
      primary: {
        dark: SiteSettings.mainColor(),
        main: SiteSettings.primaryDarkColor(),
        light: SiteSettings.mainColor(),
      },
      success: {
        main: '#62CA74',
      },
      error: {
        main: '#DF376B',
      },
      warning: {
        main: '#F3CD5C',
      },
      linkColor:'#308CBA',
      primaryColor: SiteSettings.mainColor(),
      cardBackground: '#FBFAFF',
      mainLight: '#fff',
      mainDark: SiteSettings.primaryDarkColor(),
      transparent: 'transparent',
      green: '#62CA74',
      lightGray: '#FEFDFF',
      extraLightGray: '#F0EBFA',
      borderColor: '#F3F2F4',
      
      gray: {
        extraLightGray: '#E7E6E9',
        lightGray: '#CDCFD5',
        softGray: '#B5B9BC',
        gray: '#6B737C',
        darkGray: '#39444E',
        extraDarkGray: '#081725',
        rainGray: "#C3D0E5",
        lightSoftGray: "#aeb6bd",
        placeholderLightGray: "rgba(0, 0, 0, 0.6)",
        disabledBackgroundGray: "rgba(0, 0, 0, 0.12)",
        disabledGray: "rgba(0, 0, 0, 0.26)",
        transparentGray: "rgba(0, 0, 0, 0.3)",
        zincGray: "#ADB6BE",
        backgroundGray:'#F2F1F5',
        demoGray: "#f6f9fb"
      },
      card: {
        platinum: '#9D9D9D',
        business: '#00529B',
        fleet: '#C7B68B',
      }
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 475,
        md: 768,
        lg: 1024,
        xl: 1400,
      },
    },
    typography: {
      fontFamily: 'Open Sans, sans-serif',
      h1: {
        fontFamily: 'Martel, serif',
        fontSize: '30px',
        fontWeight: 600,
        lineHeight: '51px',
        [theme.breakpoints.down('md')]: {
          fontSize: 20,
          lineHeight: '28px',
        },
      },
      h2: {
        fontFamily: 'Martel,serif',
        fontSize: '24px',
        lineHeiht: '40px',
      },
      body2: {
        fontFamily: 'Open Sans, sans-serif',
        fontWeight: 400,
      },
      body: {
        fontFamily: 'Open Sans, sans-serif',
      },
      body1: {
        fontFamily: 'Open Sans, sans-serif',
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            fontWeight: 700,
          },
        },
        variants: [
          {
            props: { variant: 'footer' },
            style: {
              color: '#fff',
              marginRight: '16px',
              textDecoration: 'underline',
            },
          },
        ],
        defaultProps: {
          disableRipple: true,
        },
      },
      MuiTypography: {
        defaultProps: {
          variantMapping: { body: 'p' },
          variant: 'body',
        },
        styleOverrides: {
          root: {},
          caption: {
            fontFamily: 'Open Sans',
          },
        },
      },
      MuiLink: {
        variants: [
          {
            props: { variant: 'footer' },
            style: {
              color: '#fff',
              textDecoration: 'underline',
            },
          },
        ],
        styleOverrides: {
          root: {
            textDecoration: 'none',
          },
        },
      },
      MuiPickersDay: {
        styleOverrides: {
          root: {
            fontFamily: 'Open Sans',
          },
        },
      },
      MuiFormHelperText: {
        styleOverrides: {
          root: {
            fontFamily: 'Open Sans',
            marginLeft: 0
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            fontFamily: 'Open Sans',
          },
        },
      },
      MuiContainer: {
        styleOverrides: {
          root: {
            height: '100%',
            [theme.breakpoints?.up('sm')]: {
              paddingLeft: 0,
              paddingRight: 0,
            },
          },
        },
        defaultProps: {
          maxWidth: 'xl',
        },
      },
      MuiTextField: {
        defaultProps: {
          fullWidth: true,
          autoComplete: 'new-password',
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: SiteSettings.mainColor(),
            },
            '&.Mui-disabled input': {
              '-webkit-text-fill-color': 'rgba(0, 0, 0, 1)'
            },
          },
          input: {
            fontFamily: 'Open Sans',
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            fontSize: '12px',
            fontFamily: 'Open Sans',
          },
        },
      },
      MuiFormControlLabel: {
        styleOverrides: {
          root: {
            fontSize: '14px',
            fontFamily: 'Open Sans',
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          root: {
            fontSize: '14px',
            fontFamily: 'Open Sans',
          },
        },
      },
    },
  });
  return theme;
}
